import { Injectable } from '@angular/core';
import { randText } from '@ngneat/falso';
import { Set } from 'immutable';

import { PermissionConfigItemEntity } from '../../../ui/components/app-permissions-configurator/permission-config-item.entity';
import {
	Permission,
	PermissionConfigListEntity,
} from '../../../ui/components/app-permissions-configurator/permission-config-list.entity';

@Injectable()
export class PermissionConfigListProvider {
	private readonly permissionConfigList: PermissionConfigListEntity;

	public constructor() {
		this.permissionConfigList = PermissionConfigListEntity.build([
			{
				permission: Permission.Read,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.Write,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.Delete,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.Export,
				toggled: false,
				isDisabled: true,
			},
			{
				permission: Permission.Share,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.PersistAndCacheData,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.ManageLink,
				toggled: false,
				isDisabled: true,
			},
			{
				permission: Permission.ManagePermission,
				toggled: false,
				isDisabled: false,
			},
			{
				permission: Permission.ManageDataCatalogue,
				toggled: false,
				isDisabled: false,
			},
		]);
	}

	public getList(): PermissionConfigListEntity {
		return this.permissionConfigList;
	}

	public setAutoElements(): PermissionConfigListEntity {
		const elements: Array<PermissionConfigItemEntity> = this.generateData();

		const elems = new Map(elements.map((item) => [`${item.id}`, item]));
		return this.permissionConfigList.setElements(elems);
	}

	private generateData(count = 5): Array<PermissionConfigItemEntity> {
		return Array.from({
			length: count,
		}).map((_, index) =>
			PermissionConfigItemEntity.build({
				id: index + 1,
				element: randText({
					charCount: 100,
				}),
				permissions: Set([Permission.Read, Permission.Write]),
			})
		);
	}
}
